import * as React from 'react'
import { styled } from 'next-yak'

import type { PolymorphicComponent, YakComponentOf } from '@owl-nest/yak/extra-runtime'

import * as S from '../../styles'
import { type RoleTagColors } from '../../styles/tag'

type ExtraRoleTagProps = {
  backgroundColor?: RoleTagColors
}

export type RoleTagProps = ExtraRoleTagProps & React.HTMLAttributes<HTMLDivElement>

function RoleTagComponent({ children, backgroundColor, ...props }: RoleTagProps): React.ReactElement<RoleTagProps> {
  return (
    <S.tag.RoleTag backgroundColor={backgroundColor} {...props}>
      {children}
    </S.tag.RoleTag>
  )
}

export const RoleTag = styled(RoleTagComponent)<RoleTagProps>`` as YakComponentOf<
  PolymorphicComponent<'div', ExtraRoleTagProps>
>

RoleTag.displayName = 'RoleTag'
